import { darkTheme, lightTheme } from "@theme/themes/ms5";

export { lightTheme, darkTheme };

export default lightTheme;
